
    /**
     * @author tribes agency
     * @description component created by Tribes
     * ============================================================================================
     */
    export default {
        name: "TribesCtaStarted",
        props: {
            description: {
                default: "Unleash your creativity and get started today with our intuitive print-on-demand design wizard. Bring your ideas to life in just a few simple steps!",
                type: String
            },
            title: {
                default: "Ready to get started?<br> Just upload your logo.",
                type: String
            },
        },
        data() {
            return {
                startLink: {
                    background: 'secondary',
                    title: "Get started",
                    url: "/get-started",
                }
            }
        }
    }
